import store from "../store";

export default function proceed(to, from, next) {
  const role =
    store.getters["auth/role"] &&
    store.getters["auth/role"].map(item => item.name);
  if (role.includes("receptionist") || role.includes("technician")) {
    to.meta.layout = "nosidebar-layout";
    next();
    return;
  } else {
    to.meta.layout = "";
    next();
  }
}
